import React, { type PropsWithChildren } from "react"

interface CheckboxProps {
  checked: boolean
  disabled?: boolean
  id?: string
  name?: string
  value: string
  onChange: () => void
}

export const Checkbox = ({
  children,
  checked,
  disabled = false,
  id,
  name,
  value,
  onChange,
}: PropsWithChildren<CheckboxProps>) => {
  return (
    <label className="flex cursor-pointer items-center">
      <div className="group relative rounded-full">
        <span className="pointer-events-none absolute inset-0 rounded-full transition-all group-hover:ring-8 group-hover:ring-gray-300/20 group-active:animate-pulse group-active:bg-blue-600/30 group-active:ring-blue-600/40" />
        <input
          className="relative scale-150 cursor-pointer rounded-full accent-blue-600"
          onChange={onChange}
          value={value}
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          disabled={disabled}
        />
      </div>

      {children}
    </label>
  )
}
